<template>
  <div class="dashboard view">
    <DashboardComponent :breadcrumb="breadcrumb"/>

    <div class="col my-3">
        <hr/>
    </div>
      <ScheduleComponent
        :user="user"
      />

    <div v-if="hasPermissions(['Assignment-Project-Template Complete'])">
      <div class="col my-3">
        <hr/>
      </div>
        <ProjectComponent
          :user="user"
        />
    </div>
    
     <div class="col my-3">
        <hr/>
    </div>

    <article class="dashboard__notes">

      <div class="d-lg-flex justify-content-lg-between">
        <div class="dashboard__links order-lg-2 align-self-md-start mt-lg-1" v-if="!has_role('Employee')">
          <a @click="note_form_modal()">
            <span class="mr-0">
              New Note
              <i class="prefix">
                <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px" />
              </i>
            </span>
          </a>
        </div>

        <div class="dashboard__title mt-lg-0 d-lg-flex align-items-lg-center" v-if="global_notes.length">
          <h1 class="title--1 mr-lg-3 mb-lg-0" v-html="'Notes'"/>
          <p class="overview__text" v-html="'Friendly reminders'"/>
        </div>
        <div class="dashboard__title mt-lg-0 d-lg-flex align-items-lg-center" v-else/>
      </div>

      <div class="row detail__content__notes" style="max-height:500px;" v-if="global_notes.length">
        <div class="col-lg-3" v-for="(note, i) in display_global_notes" :key="i">
          <div class="row mb-0 no-gutters h-100">
            <div class="col-12 card cardList hoverable">
              <div class="card-content h-100">
                <div class="card-title">
                  <div class="row mb-0 no-gutters">
                    <div class="col-10">
                      <a class="textTitleCard" v-html="`${note.title} <span style='font-size: 13px; font-weight: normal;'> / ${note.created_at}</span>`" @click="note.creator_associate_id === user.id ? note_modal_update(i) : null"/>
                    </div>
                    <div class="col-2 text-right" v-if="!has_role('Employee')">
                      <a @click="!has_role('Employee') ? note_modal_deletion(i) : null">
                        <i class="material-icons prefix" >
                          <img class="iconCard" src="/assets/img/trash.png" alt="date" style="right: 0rem; top: -6px; width: 24px; height: auto;" />
                        </i>
                      </a>
                    </div>
                  </div>
                  <div class="row mb-0 no-gutters">
                    <div class="col-12">
                      <div v-if="note.associate !== null && !has_role('Employee')" style="font-size: 13px; font-weight: initial; color: gray; margin-top:15px;">
                        <span v-html="`<b>To</b>: ${note.associate}`"/>
                      </div>
                      <div v-else-if="note.associate === null && !has_role('Employee')" style="font-size: 13px; font-weight: initial; color: gray; margin-top:15px;">
                        <span v-html="`<b>To</b>: My whole team`"/>
                      </div>
                      <p class="mt-3 card-content__text" v-html="note.body_text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </article>
    <div class="col my-3">
        <hr/>
    </div>
    <MessageComponent rest_api="messages"/>


    <DeletionModal 
        :single_object="single_note" 
        :global_index="note_global_index" 
        @objectDeletion="note_trash($event)"
    />

    <NoteFormModal
      v-if="!has_role('Employee')"
      :title="'New Note'"
      :breadcrumb="breadcrumb"
      :rest_api="global_notes_rest_api"
      :notyf="notyf"
      :array_options="global_notes_array_options"
      @unshiftObject="note_unshift_object($event)"
    />

    <NoteUpdateModal
      v-if="!has_role('Employee')"
      :title="'Note Update'"
      :breadcrumb="breadcrumb"
      :rest_api="global_notes_rest_api"
      :notyf="notyf"
      :single_object="single_note"
      :global_index="note_global_index"
      :array_options="global_notes_array_options"
      @spliceObject="note_splice_object($event)"
      ref="note_update_modal"
    />

    <WaitingModal/>

    <HelperModal :helps="helps"/>

  </div>
</template>

<script>

import NoteFormModal from './NoteFormModal'
import NoteUpdateModal from './NoteUpdateModal'
import DeletionModal from '@/components/DeletionModal'
import Resources from './resources'
import WaitingModal from '@/components/WaitingModal'
import HelperModal  from    '@/components/HelperModal'

import MessageComponent from './MessageComponent'
import ScheduleComponent from './ScheduleComponent'
import ProjectComponent from './ProjectComponent'

import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
import DashboardComponent from './DashboardComponent.vue'

const notyf = new Notyf({
    duration: 8000,
})

export default {

  name: "Home",

  components: {
    NoteFormModal,
    WaitingModal,
    NoteUpdateModal,
    DeletionModal,
    MessageComponent,
    ScheduleComponent,
    ProjectComponent,
    DashboardComponent,
    HelperModal
},

  data()
  {

    return{
      notyf,
      user: this.get_user(),
      rest_api: 'dashboard',
      note_global_index: null,
      single_note: {},
      global_notes: [],
      global_notes_rest_api: 'global_notes',
      current_assignment: {},

      global_notes_array_options: {
        associate_id: [],
        date_method: [
          {
            id: 1,
            name: 'Days',
          },
          {
            id: 2,
            name: 'Hours',
          }
        ]
      },
      breadcrumb: Resources.breadcrumb,
      helps: Resources.helps
    }
  },

 

  methods:{

    async note_trash(object_destroyed)
    {
      this.invoke_loader('delete')
      const response = await this.delete(`${this.global_notes_rest_api}/${object_destroyed.id}`)
      if(response.status)
      {
        this.note_global_index = ''
        this.single_note = {}
        this.global_notes.splice(object_destroyed.index, 1)
        notyf.success('Deleted success!')
        window.$('#static-deletion').modal('hide')
        this.revoke_loader('delete')
      } 
      else
      {
        this.error_handling(response)
        this.revoke_loader('delete')
      }
    },
    
    note_unshift_object(new_object)
    {
        this.global_notes.unshift(new_object)
    },

    note_splice_object(splicing_object)
    {
      this.global_notes.splice(splicing_object.index, 1, splicing_object.single_object)
    },

    note_modal_deletion(index)
    {
        this.note_global_index = index
        this.single_note = this.global_notes[index]
        window.$('#static-deletion').modal('show')
    },

    async global_notes_api_request()
    {
      this.loader(true)
      
      const response = await this.get(this.global_notes_rest_api)
      
      if(response.status)
      {
          this.global_notes = response.data.notes
          this.global_notes_array_options.associate_id = response.data.associates
          const select_all_associates = {
            id: 0,
            name: 'My whole team'
          }
          this.global_notes_array_options.associate_id.unshift(select_all_associates)
          this.current_assignment = response.data.daily_assignment
          this.loader()
      } 
      else
      {
          this.error_handling(response)
          this.loader()
      }
    },
    note_form_modal()
    {
      if(!this.user.has_facility)
      {
        notyf.error('There is not exists a facility yet')
        return false
      }
      window.$('#static').modal('show')
    },

    note_modal_update(index)
    {
      this.note_global_index = index
      this.single_note = {...this.global_notes[index]}
      this.$refs.note_update_modal.mountUpdate()
      window.$('#static-update').modal('show')
    },
    

  },

  computed: {

    display_global_notes()
    {
      return this.global_notes
    },

  },

  async mounted()
  {
    await this.global_notes_api_request()

  }

}
</script>
